import AxiosInstance from '../../helpers/axios-instance/axios-instance';
import type { ProcessAnalysisKPIData, ProcessAnalysisKPIParams } from './process-analysis-client.type';

const axiosInstance = AxiosInstance();
const baseURL = import.meta.env.VITE_APP_API_URL + '/api/';

/**
 * Fetches KPI data for process analysis
 *
 * @param {ProcessAnalysisKPIParams} params - Parameters for the KPI request
 * @returns {Promise<ProcessAnalysisKPIData>} Promise containing KPI data
 */
async function getProcessAnalysisKPIs(params: ProcessAnalysisKPIParams): Promise<ProcessAnalysisKPIData> {
  const apiURL = baseURL + 'process-analysis/kpis';

  const queryParams: Record<string, string> = {};

  if (params.subproject_ids && params.subproject_ids.length > 0) {
    queryParams.subproject_ids = params.subproject_ids.join(',');
  }

  if (params.project_ids && params.project_ids.length > 0) {
    queryParams.project_ids = params.project_ids.join(',');
  }

  if (params.portfolio_ids && params.portfolio_ids.length > 0) {
    queryParams.portfolio_ids = params.portfolio_ids.join(',');
  }

  if (params.start_date) {
    queryParams.start_date = params.start_date;
  }

  if (params.end_date) {
    queryParams.end_date = params.end_date;
  }

  return axiosInstance
    .get<ProcessAnalysisKPIData>(apiURL, { params: queryParams })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response || 'Error fetching process analysis KPIs'));
}

export { getProcessAnalysisKPIs };
